<template>
  <div id="tienda">
    <v-toolbar class="sub-toolbar" flat>
      <v-btn flat class="primary-color back mr-auto" :to="'/looks'"><v-icon class="mr-2">arrow_back</v-icon>{{ $t('lang.comun.salir') }}</v-btn> 
      <Menu>
        <template v-slot:filtro>&nbsp;</template>
        <template v-slot:tickets-aparcados>&nbsp;</template>
      </Menu>
      <transition name="fade">
        <Carrito v-if="$store.getters.isCarritoModalOpen"></Carrito>
      </transition>
    </v-toolbar>
    <div class="lookviewer">
      <div v-if="cargando" class="cargando">
            <v-progress-circular
            indeterminate
            color="#2562a4"
          ></v-progress-circular>
      </div>
      <div  v-else >
        <div class="image-container px-4 mb-3">
          <h1 class="primary-color pt-3 text-uppercase">{{titulo}}</h1>
           <h2 class="font-weight-regular text-uppercase pb-3" >{{descripcion}}</h2>
           <div class="d-flex no-flex justify-center align-center">
              <img class="elevation-1 ml-auto mr-auto d-flex" :src="'data:image/jpeg;base64,' + imagen" v-show="imagen!=''">
           </div>
        </div>
        <div class="look-articulos d-flex px-4">
          <div class="d-flex no-flex" v-for="(lookArticulo,index) in lookArticulos" :key="index" @click="verArticulo(lookArticulo.articulo)">
              <look-articulo :articulo="lookArticulo.articulo" ></look-articulo>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
        <modal-detalle :producto="prodAux" :opId="$store.getters.getIdTienda" v-if="modal" v-on:cerrar="modal = false"></modal-detalle>
    </transition>
  </div>
</template>
<script>
import { LookApiService } from '@/api/LookApiService'
import LookArticulo from './LookArticulo.vue';
import DetalleProducto from '@/views/tienda/components/modal/DetalleProducto';
import Menu from '@/views/tienda/components/menu/Menu';
import Carrito from '@/views/tienda/components/modal/Checkout';

const lookApiService = new LookApiService()

export default {
  name: "LookViewer",
  props: ['lookid'],
  components: {LookArticulo,Menu,Carrito,'modal-detalle' : DetalleProducto },
  data() {
    return {
      imagen: '',
      titulo: '',
      descripcion: '',
      lookArticulos: [],
      cargando: false,
      prodAux: null,
      modal: false
    }
  },
  created() {
    this.$store.commit('showCarritoModal', false);
    this.cambioTitulo()
    this.init()
  },
  methods: {
    cambioTitulo () {
      this.$store.state.tituloIcono = `<v-icon class="v-icon material-icons primary-color">checkroom</v-icon>`
      this.$store.state.titulo = "Look"
    },
    init() {
      this.getLook()
    },
    getLook() {
      this.cargando = true
      lookApiService.getLookById(this.lookid)
        .then(data => {
          this.cargando = false
          this.titulo = data.mslTitulo
          this.descripcion = data.mslDesc
          this.imagen= data.mslImagen
          console.log(data.lookArticulos)
          this.lookArticulos = data.lookArticulos.filter((value, index, self) =>
                                    index === self.findIndex((t) => (
                                    t.mslaIdArtic === value.mslaIdArtic
                                )))
        })
    },
    verArticulo(articulo) {
      this.prodAux = articulo
      this.modal = true
    }
  }
}
</script>